import apiClient from "@/app/api/client";
import type { CreateUserInput, ManagedUser, UpdateUserInput } from "../types";

interface SingleUserResponse {
	success: true;
	data: ManagedUser;
}

export const usersService = {
	async create(input: CreateUserInput): Promise<ManagedUser> {
		const response = await apiClient.post<SingleUserResponse>("/users", input);
		return response.data.data;
	},

	async update(id: string, input: UpdateUserInput): Promise<ManagedUser> {
		const response = await apiClient.patch<SingleUserResponse>(`/users/${id}`, input);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/users/${id}`);
	},

	// ⚠️ `scope` berilsa `department:‹uuid›` shaklida bo'lishi kerak
	// (`assignmentScopeSchema`). Endi `POST /role-assignments` — UPSERT
	// (spec 2026-09-12-p5 §3.4): joriy rol jimgina almashadi.
	async assignRole(subjectId: string, roleId: string, scope?: string): Promise<void> {
		await apiClient.post("/role-assignments", { subjectId, roleId, scope });
	},

	async revokeRole(subjectId: string, roleId: string): Promise<void> {
		await apiClient.delete(`/role-assignments/by-user/${subjectId}/role/${roleId}`);
	},
};
